<template>
  <div class="body">
    <TopNav :showDetail="!showDetail"></TopNav>
    <Main></Main>
    <Service></Service>
    <Footer></Footer>
    <Feedback></Feedback>
  </div>
</template>

<script>
import Main from "./Main"
import TopNav from "../advantage/TopNav"
import Content from "./Content"
import Service from "../default2/Service"
import Footer from "../default2/Footer"
import Feedback from "../default2/Feedback"

export default {
  components: {
    TopNav,
    Service,
    Footer,
    Main,
    Feedback
  },
}
</script>

<style></style>
